import { createFileRoute, notFound } from "@tanstack/react-router";
import { findKotaBySlug, getKecamatanInKota } from "@/data/locations";
import { displayLocationTitle } from "@/lib/prayer/copy";
import { BukaPuasaPage } from "@/components/prayer/BukaPuasaPage";
import { SiteShell } from "@/components/layout/SiteShell";
import { EmptyLocationState } from "@/components/prayer/EmptyLocationState";

export const Route = createFileRoute("/jadwal-buka-puasa/$kota/$kec")({
  loader: ({ params }) => {
    const kota = findKotaBySlug(params.kota);
    if (!kota) throw notFound();
    const kec = getKecamatanInKota(params.kota).find((k) => k.slug === params.kec);
    if (!kec) throw notFound();
    return { loc: kec, kota };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { loc } = loaderData;
    const display = displayLocationTitle(loc);
    const title = `Jadwal Buka Puasa ${display} - Waktu Maghrib`;
    const desc = `Waktu buka puasa (maghrib) untuk ${display} sesuai metode Kemenag RI. Update otomatis dan akurat per kecamatan.`;
    const canonical = `https://hari.co.id/jadwal-buka-puasa/${loc.parentSlug}/${loc.slug}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
        { property: "og:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "robots", content: "index, follow, max-image-preview:large" },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: () => {
    const { loc } = Route.useLoaderData();
    return <BukaPuasaPage location={loc} />;
  },
  notFoundComponent: () => (
    <SiteShell>
      <EmptyLocationState variant="buka-puasa" />
    </SiteShell>
  ),
});